import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import 'antd/dist/antd.min.css';
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Styles } from "./styles/styles";
import i18n from "./translation";

const App = () => (
  <I18nextProvider i18n={i18n}>
    <Styles />
    <Header />
    <Home />
    <Footer />
  </I18nextProvider>
);

ReactDOM.render(<App />, document.getElementById("root"));
